import { Component, OnInit } from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { USERS, PLANTS, USER_DETAIL, TRANSPORT_TYPES, DASHBOARD_STATUS_CONFIG, NOTIFICATION_CONFIG } from "../../../core/constants/route_paths";
import { AuthService } from 'src/app/core/services/auth.service';
import { DialogConfirmComponent } from '../../shared/dialog-confirm/dialog-confirm.component';
@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  public panelOpenState: boolean;
  public titlePage: string;
  public disabled: boolean;
  public routesPath: object;

  constructor(
    private dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private authservice: AuthService
  ) {
    this.panelOpenState = true;
    this.titlePage = "";
    this.disabled = false;
    this.routesPath = {
      users: `/${USERS}`,
      plants: `/${PLANTS}`,
      transportTypes: `/${TRANSPORT_TYPES}`,
      dashboardStatusConfig: `/${DASHBOARD_STATUS_CONFIG}`,
      notificationConfig: `/${NOTIFICATION_CONFIG}`,
    };

    this.router.events.subscribe((data) => {
      if (this.route.snapshot.firstChild.firstChild.data.title) {
        this.titlePage = this.route.snapshot.firstChild.firstChild.data.title;
      }
    });
  }

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  ngOnInit() {
    let currentUser = localStorage.getItem("currentUser");
    if (currentUser == undefined || currentUser == null) {
      this.disabled = true;
    }
    this.router.events.subscribe((data) => {
      if (this.route.snapshot.firstChild.firstChild.data.title) {
        this.titlePage = this.route.snapshot.firstChild.firstChild.data.title;
        let title = (this.router.url as string).split("/");
        if(title[1] == USER_DETAIL && title.length == 2){
          this.titlePage = this.translate.instant("label.newUser");
        }
      }
    });
  }

  switchLang(lang: string) {
    this.translate.use(lang);
    this.titlePage = this.route.snapshot.firstChild.firstChild.data.title;
    sessionStorage.setItem("currentLang", lang);
  }

  logOut() {
    let dialogRef;
    dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        title: this.translate.instant("label.titleLogOut"),
        description: this.translate.instant("label.descriptionLogOut"),

      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
          this.authservice.logout();
          this.router.navigate(['/'])
      } else {
        this.dialog.closeAll();
      }
    });
    
  }

  isSelected(lang: string) {
    let currentLang = sessionStorage.getItem("currentLang");
    return lang == currentLang ? true : false;
  }
}
